export default __webpack_public_path__ + "static/media/icon7.e02d7610.svg";